module.exports = __webpack_public_path__ + "img/device_shield.1fa1afcd.svg";